import {fetchInductOverview} from "../network/InductNetworkAPI";

export const InductOverviewReducer = (state, action) => {
    switch (action.type) {
        case "LOAD_VIEW":
            const {filter, capability, dispatcher} = action.data;
            fetchInductOverview(filter, capability, dispatcher)
            return state
        case "RECEIVE_DATA":
            return {...state, ...action.data}
        case "INDUCT_STATUS_DATA":
            return {...state, ...action.data}
        case "RECEIVE_STOW_DATA":
            return {...state, ...action.data}
        case "RECEIVE_PLANNED_DATA":
            return {...state, ...action.data}
        default:
            return state
    }
}


// WEBPACK FOOTER //
// ./src/components/induct/reducers/InductOverviewReducer.js